'use client';

import React from 'react';

// Sour Suver strain terpene profile data with REAL scientific effects from CSV research
const terpeneData = [
  { name: 'Terpinolene', value: 5.61, color: '#a78bfa', effect: 'Anticancer, Antioxidant' },
  { name: 'beta-Myrcene', value: 4.43, color: '#86efac', effect: 'Anti-inflammatory, Anti-tumor' },
  { name: 'beta-Caryophyllene', value: 2.80, color: '#f9a8d4', effect: 'Antimicrobial, Anti-tumor' },
  { name: 'alpha-Humulene', value: 0.89, color: '#6ee7b7', effect: 'Anti-inflammatory, Anticancer' },
  { name: 'Ocimene', value: 0.86, color: '#93c5fd', effect: 'Antibacterial, Antifungal' },
  { name: 'Terpineol', value: 0.80, color: '#bef264', effect: 'Antimalarial, Antioxidant' },
  { name: 'Limonene', value: 0.69, color: '#fde047', effect: 'Anticancer, Anxiolytic' },
  { name: 'alpha-Bisabolol', value: 0.60, color: '#fca5a5', effect: 'Anti-inflammatory, Antimicrobial' },
  { name: 'beta-Pinene', value: 0.28, color: '#c4b5fd', effect: 'Anti-inflammatory, Antidepressant' },
  { name: 'alpha-Pinene', value: 0.27, color: '#fdba74', effect: 'Anti-inflammatory, Anxiolytic' },
  { name: '3-Carene', value: 0.19, color: '#fb923c', effect: 'Anti-inflammatory, Bone growth' },
  { name: 'alpha-Terpinene', value: 0.16, color: '#7dd3fc', effect: 'Antioxidant, Antimicrobial' },
  { name: 'Valencene', value: 0.12, color: '#fef3c7', effect: 'Food/Beverage Ingredient' },
  { name: 'alpha-Phellandrene', value: 0.11, color: '#e9d5ff', effect: 'Antidepressant, Anti-inflammatory' },
  { name: 'Nerolidol', value: 0.09, color: '#d9f99d', effect: 'Antifungal, Antimalarial' },
  { name: 'Linalool', value: 0.08, color: '#fda4af', effect: 'Sedative, Anti-anxiety' },
  { name: 'Sabinene', value: 0.05, color: '#fbbf24', effect: 'Antimicrobial, Antifungal' }
];

export function TerpeneList() {
  return (
    <div className="space-y-1.5 max-h-[200px] overflow-y-auto pr-2 custom-scrollbar">
      {terpeneData.map((terpene) => (
        <div key={terpene.name} className="flex items-center justify-between py-1 px-2 rounded bg-white/[0.02] hover:bg-white/[0.04] transition-colors">
          <div className="flex items-center gap-2 flex-1">
            <span 
              className="w-2 h-2 rounded-full flex-shrink-0" 
              style={{ backgroundColor: terpene.color }}
            />
            <span className="text-white/90 text-xs font-mono min-w-[140px]">
              {terpene.name}
            </span>
            <span className="text-emerald-400/70 text-[11px] italic flex-1">
              {terpene.effect}
            </span>
          </div>
          <span className="text-white font-mono text-xs ml-2">
            {terpene.value.toFixed(2)}%
          </span>
        </div>
      ))}
    </div>
  );
}